module.exports = __webpack_public_path__ + "img/used_seal.426a5dd0.png";